import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {defaultLocalizationNamespaces} from "./constants/defaultLocalizationNamespaces";
import en from "./i18n/translations/en";
import tr from "./i18n/translations/tr";
const LANGUAGES = {en, tr};

i18n.use(initReactI18next).init({
    appendNamespaceToCIMode: true,
    resources: LANGUAGES,
    cleanCode: true,
    debug: Boolean(process.env.DEBUG),
    defaultNS: "common",
    fallbackLng: "tr",
    interpolation: {
        escapeValue: false
    },
    load: "languageOnly",
    ns: defaultLocalizationNamespaces,
    react: {
        bindI18n: "languageChanged",
        bindI18nStore: "",
        transEmptyNodeValue: "",
        transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
        transSupportBasicHtmlNodes: true
    },
    supportedLngs: ["en", "tr"],
    whitelist: ["en", "tr"]
});

export default i18n;
